/*
 * @Description: 
 * @Version: 1.0
 * @Autor: 马璇玲
 * @Date: 2020-06-01 16:42:16
 * @LastEditors: 马璇玲
 * @LastEditTime: 2020-08-27 17:36:48
 */ 
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Vant from 'vant'
import store from './store/index'
import { 
  // Uploader,
  Toast,
  // Dialog,
  // Picker 
} from 'vant';


// style
import './assets/css/common.css'
import 'vant/lib/index.css'
import './assets/css/vanRepaint.css'
import './assets/css/fonsSize.css'
import './assets/css/color.css'
import './assets/css/subject.css'
import './assets/css/iconfont.css'

import appSdk from './utils/appTool'

// 增加全局bus
Vue.prototype.$bus = {}

Vue.prototype.$appSdk = appSdk

Vue.use(VueAwesomeSwiper)

Vue.use(Vant)
Vue.use(Toast)


Vue.prototype.$toast = Toast;
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

Vue.config.errorHandler = function (err, vm, info) {
  // 处理错误
  // `info` 是 Vue 特有的错误信息，例如，错误是在哪个生命周期钩子函数中发现的。
  // info 只在 2.2.0+ 可访问
  if (err) {
    console.log(`${err} ${info} ${vm}`)
  }
}

/* eslint-disable no-new */
window.vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js